import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'project-report-selector',
    template: require('./project.report-selector.component.html')
})
export class ProjectReportSelectorComponent implements OnInit {
    @Input() reportName: string;
    @Input() projectMenu: any;

    frsEnabled = false;
    trackerEnabled = false;
    scmEnabled = false;
    isProjectAdmin = false;

    constructor(
        private stateService: StateService, 
        
    ) {}

    ngOnInit(): void {
        this.frsEnabled = this.moduleEnabled('frs');
        this.trackerEnabled = this.moduleEnabled('tracker');
        this.isProjectAdmin = this.projectMenu?.admin ?? false;
        this.scmEnabled = this.getModules().some(module => ['scmcvs', 'scmsvn', 'scmgit'].includes(module));
    }

    private getModules(): string[] {
        return this.projectMenu?.modules ?? [];
    }

    private moduleEnabled(moduleName: string): boolean {
        return this.getModules().includes(moduleName);
    }
}
